/**
 * Labstep
 *
 * @module components/PurchaseOrder/Form/ShowEdit/Currency
 * @desc Currency showedit field
 */

import { fieldPurchaseOrderCurrency } from 'labstep-web/components/PurchaseOrder/Form/fields';
import { FormShowEditSelect as ShowEditSelect } from 'labstep-web/core/Form/ShowEdit/Select';
import type React from 'react';
import type { IPurchaseOrderFormShowEditCurrencyProps } from './types';

export const PurchaseOrderFormShowEditCurrency: React.FC<
  IPurchaseOrderFormShowEditCurrencyProps
> = ({ purchaseOrder }) => (
  <ShowEditSelect
    entity={purchaseOrder}
    field={fieldPurchaseOrderCurrency}
  >
    {purchaseOrder.currency}
  </ShowEditSelect>
);
